import * as React from 'react';
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { getDistance } from 'ol/sphere';
import { transform } from 'ol/proj';
import OlMap from 'ol/Map';
import { Telemetry, TelemetryEventType, TelemetrySource } from '@shared/Telemetry';

@observer
export class MapScale extends React.Component<
    {
        mapInstance?: OlMap;
    },
    {}
> {
    @observable scale = 1000;
    @observable ppi = (() => {
        for (let i = 56; i < 1000; i++) {
            if (matchMedia(`(max-resolution: ${i}dpi)`).matches === true) {
                return i;
            }
        }
        return 96;
    })();

    @observable inputScale = '1000';

    constructor(props: { mapInstance?: OlMap }) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        console.log('ppi:', this.ppi);
        this.props.mapInstance.on('moveend', this.calcScale);
    }

    render() {
        return (
            <div className='flex-row centered' style={{ fontSize: 12 }}>
                <span>1 / &nbsp;</span>
                <input
                    type='text'
                    value={this.inputScale}
                    style={{
                        width: this.inputScale.length * 10,
                        background: 'transparent',
                        border: '1px solid rgba(0,0,0,0.1)',
                        fontSize: 12,
                    }}
                    onChange={e => {
                        this.inputScale = e.currentTarget.value;
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            this.setScale(parseFloat(e.currentTarget.value));
                            Telemetry.add(TelemetryEventType.MAP_ZOOM_NUMERIC, TelemetrySource.MAP_2D_DESKTOP, this.inputScale);
                        }
                    }}
                />
            </div>
        );
    }

    calcScale = () => {
        const proj = this.view.getProjection();
        const center = this.view.getCenter();
        const px = this.map.getPixelFromCoordinate(center);
        px[1] += 1;
        const coord = this.map.getCoordinateFromPixel(px);
        let d = getDistance(transform(center, proj, 'EPSG:4326'), transform(coord, proj, 'EPSG:4326'));
        d *= this.ppi / 0.0254;
        this.scale = d;

        const scaleRound = Math.round(this.scale > 100 ? (this.scale / 100) * 100 : this.scale);
        this.inputScale = scaleRound ? scaleRound + '' : '1000';
    };

    setScale = (target: number) => {
        if (!target || target < 1) target = 1000;
        const proj = this.view.getProjection();
        const center = this.view.getCenter();
        const px = this.map.getPixelFromCoordinate(center);
        px[1] += 1;
        const coord = this.map.getCoordinateFromPixel(px);
        let d = getDistance(transform(center, proj, 'EPSG:4326'), transform(coord, proj, 'EPSG:4326'));
        d *= this.ppi / 0.0254;
        this.view.setResolution((this.view.getResolution() * target) / d);

        this.calcScale();
    };

    getScale = () => {
        return this.scale;
    };

    get map() {
        return this.props.mapInstance;
    }

    get view() {
        return this.props.mapInstance.getView();
    }
}
